module.exports = __webpack_public_path__ + "3-60.jpg?18e640ddff0ea99ee5f3032b8587e5c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-60.jpg
// module id = 142
// module chunks = 0